import { render } from "./PtResourceTool.vue?vue&type=template&id=6d88c08a&scoped=true"
import script from "./PtResourceTool.vue?vue&type=script&lang=js"
export * from "./PtResourceTool.vue?vue&type=script&lang=js"

import "./PtResourceTool.vue?vue&type=style&index=0&id=6d88c08a&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d88c08a"]])

export default __exports__